import { Action, FilterSection } from '~/components';
import { IcCircleDot, Typography, theme } from '@bgzt/ui';
import { FilterValue } from '~/apis/search';
import { ForwardedRef, forwardRef } from 'react';
import { convertPayload } from '~/components/FilterBottomSheet/_utils/payload-utils';

import styles from './SingleRound.module.css';

type Props = {
  onChange: (action: Action) => void;
  options: FilterValue[];
  value: string;
  filterKey: string;
  title: string;
};

export const SingleRound = forwardRef(function SingleRound(
  { onChange, options, filterKey, value: currentValue, title }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <FilterSection title={title} ref={ref}>
      <div className={styles.container}>
        {options.map(({ name, value }) => {
          const isSelected = (value ?? '') === currentValue;
          return (
            <button
              className={styles.menuButton}
              onClick={() => {
                onChange({ type: filterKey, payload: convertPayload(value) });
              }}
              key={name + value}
            >
              <Typography variant="L4" color="gray-900">
                {name}
              </Typography>

              <IcCircleDot size={20} fill={isSelected ? theme.colors['red-500'] : theme.colors['gray-100']} />
            </button>
          );
        })}
      </div>
    </FilterSection>
  );
});
